import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import LogoKR from "../assets/logo-k-ko.png";
import LogoEN from "../assets/logo-b-en.png";
import { useDispatch, useSelector } from "react-redux";
import { getPriortiyCampaign, logout } from "../Store/Action";
import default_image from "../assets/default_image.png";
import { getWithExpiry } from "@/utils/token";
const S3_URL = import.meta.env.VITE_S3_URL;
import clsx from 'clsx';
import {useThemeClass} from '@/Hooks/useThemeClass'
import {useThemeAsset} from '@/Hooks/useThemeAsset'
import addScrollParam from "@/utils/addScrollParam";

function Navbar() {
  const themeClass = useThemeClass()
  const {logoNavbar, grayscaleLogo} = useThemeAsset()

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [lastSearchTime, setLastSearchTime] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const isHidden =
    location.pathname !== "/" && location.pathname !== "/detailCategory";
  const searchText = useSelector(
    (state) => state.ReducerPriorityCampign.searchText
  );
  const dataUser = useSelector(
    (state) => state.ReducerloginUser.loginedUser.data
  );
  const [isSearch, setIsSearch] = useState(false);
  const [isLogin, setisLogin] = useState(false);
  const [showKorean, setShowKorean] = useState(true);
  const token = getWithExpiry("token");
  const match = location.pathname.match(/^\/review-guide\/[^/]+$/);

  let locationPath = location.pathname.split('/').filter(Boolean)[0]
  const [navIsAktif, setNavIsAktif] = useState(locationPath || locationPath === undefined ? "home" : "")

  console.log(locationPath);
  useEffect(()=> {
    if (!locationPath){
      locationPath = 'home'
    }
    setNavIsAktif(locationPath)
  },[location])

  const handlelogout = () => {
    dispatch(logout());
    setIsSidebarOpen(false);
    navigate("/login");
  };

  const handleMypageClick = () => {
    setIsSidebarOpen(false);
    if (!token) {
      navigate("/login");
      setisLogin(false);
    } else {
      navigate("/mypage");
      setisLogin(true);
    }
    setNavIsAktif("login")
  };

  const buttonSearch = () => {
    setIsSearch(true);
    // 검색창 열면 바로 포커스 (애니메이션 후)
    setTimeout(() => {
      const searchInput = document.getElementById("default-search");
      if (searchInput) {
        searchInput.focus();
      }
    }, 300);
  };

  const closeSearch = () => {
    setIsSearch(false);
    setSearchQuery("");
    // URL에서 q 파라미터 제거
    const params = new URLSearchParams(location.search);
    params.delete("q");
    navigate(
      `${location.pathname}${params.toString() ? "?" + params.toString() : ""}`,
      { replace: true }
    );
    dispatch({ type: "SET_SEARCH_TEXT", payload: "" });
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get("q");
    if (searchParam) {
      setSearchQuery(searchParam);
      dispatch({ type: "SET_SEARCH_TEXT", payload: searchParam });
    } else {
      // URL에 q가 없을 때만 초기화 (검색창이 닫힐 때만)
      if (!isSearch) {
        setSearchQuery("");
      }
    }
  }, [location.search, dispatch, isSearch]);

  const handleSearch = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const trimmedQuery = searchQuery.trim();

    // 현재 URL의 검색어와 같으면 검색 스킵
    const currentParams = new URLSearchParams(location.search);
    const currentQuery = currentParams.get("q") || "";
    if (trimmedQuery === currentQuery) {
      console.log("같은 검색어, 스킵:", trimmedQuery);
      return;
    }

    if (trimmedQuery) {
      // 홈 페이지가 아니면 홈으로 이동
      if (location.pathname !== "/") {
        navigate(addScrollParam(`/?q=${encodeURIComponent(trimmedQuery)}`, "recent"));
      } else {
        // 홈 페이지면 URL만 업데이트
        // Scroll to 신규캠페인 section after any search
        navigate(addScrollParam(`/?q=${encodeURIComponent(trimmedQuery)}`, "recent"), { replace: true });
      }

      // Redux 업데이트
      dispatch({
        type: "SET_SEARCH_TEXT",
        payload: trimmedQuery,
        meta: { immediateSearch: true },
      });
    } else {
      // 검색어 비어있을 때
      currentParams.delete("q");
      navigate(
        `${location.pathname}${
          currentParams.toString() ? "?" + currentParams.toString() : ""
        }`,
        { replace: true }
      );
      dispatch({ type: "SET_SEARCH_TEXT", payload: "" });
    }

    // 마지막 검색 시간 업데이트
    setLastSearchTime(Date.now());
  };

  useEffect(() => {
    if (!token) {
      setisLogin(false);
    } else {
      setisLogin(true);
    }
  }, [token]);

  // 중복 API 호출 제거 - Recent.tsx에서 이미 처리함
  // useEffect(() => {
  //   if (searchText?.trim() !== "") {
  //     const filter = { keyword: searchText };
  //     dispatch(getPriortiyCampaign(filter));
  //   }
  // }, [searchText, dispatch]);

  // Redux searchText와 동기화 제거 - blur 시 초기화 방지
  // useEffect(() => {
  //   setSearchQuery(searchText);
  // }, [searchText]);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowKorean((prev) => !prev);
    }, 3000); // 3초마다 전환

    return () => clearInterval(interval); // 컴포넌트 언마운트 시 인터벌 정리
  }, []);

  // 경로 변경 시 검색창만 닫기
  useEffect(() => {
    setIsSearch(false);
  }, [location.pathname]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const savedProfileImage = dataUser?.profile_image
    ? `${S3_URL}${dataUser?.profile_image}`
    : default_image;
  // console.log(savedProfileImage);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleRefresh = (link) => {
    setIsSidebarOpen(false);
    if (token && link === "/mypage/updateprofile") {
      navigate(link);
      window.location.reload();
    } else if (!token && link === "/mypage/updateprofile") {
      navigate("/login");
      window.location.reload();
    } else if (link.startsWith("http")) {
      window.location.href = link;
    } else {
      navigate(link);
      window.location.reload();
    }
  };

  return (
    <>
      {isSidebarOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black opacity-80 z-20"
          onClick={toggleSidebar} // Klik di luar sidebar untuk menutup
        ></div>
      )}
      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-[70%] bg-white p-6 transition-transform transform ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ zIndex: 100 }}
      >
        <div className="flex flex-col w-full">
          <button
            className="mb-3 flex justify-end text-end items-end"
            onClick={toggleSidebar}
          >
            <svg
              className="w-8 h-8 text-[#D9D9D9]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18 17.94 6M18 18 6.06 6"
              />
            </svg>
          </button>
          <div className="flex justify-between py-3 items-center">
            <div className="">
              <img src={logoNavbar} alt="Logo" className="h-8 mx-auto p-1" />
            </div>
            {!isLogin ? (
              <button
                className={clsx(themeClass.bg('text'), 'text-sm text-white rounded-full px-6 py-2')}
                onClick={() => {
                  setIsSidebarOpen(false); // Tutup hamburger
                  navigate("/login"); // Navigasi ke login
                }}
              >
                로그인
              </button>
            ) : (
              <button
                className="bg-[#999999] text-sm text-white rounded-full px-6 py-2"
                onClick={handlelogout}
              >
                로그아웃
              </button>
            )}
          </div>
          {!isLogin ? (
            <>
              <div className={clsx(themeClass.text('text'), themeClass.border('text'), `flex pb-3 border-b text-lg font-bold justify-center pt-3`)}>
                로그인을 해주세요.
              </div>
            </>
          ) : (
            <div className={clsx(themeClass.text('text'), themeClass.border('text'), `flex pb-3 border-b text-lg font-bold justify-between pt-3`)}>
              <div className="">
                {!savedProfileImage ? (
                  <img src={default_image} className="w-8 h-8 rounded-full" />
                ) : (
                  <img
                    src={savedProfileImage}
                    className="w-8 h-8 rounded-full"
                  />
                )}
              </div>
              <div className="">{dataUser?.nick_name}</div>
              <div className="w-8 h-8"></div>
            </div>
          )}

          <div className="flex flex-col font-semibold text-sm pt-5">
            {[
              { text: "프로필 수정", link: "/mypage/updateprofile" },
              // { text: "배송지 관리", link: "/address" },
              // { text: "공지사항", link: "/notices" },
              { text: "자주묻는 질문", link: "/customerservice" },
              { text: "1:1 문의", link: "https://pf.kakao.com/_VGfsn" },
              { text: "이용약관", link: "" },
              { text: "개인정보 취급방침", link: "" },
              { text: "광고문의", link: "/contact" },
            ].map(({ text, link }, idx) => (
              <div
                key={idx}
                className={clsx(themeClass.text('text'), `flex justify-between py-6`)}
                onClick={() => handleRefresh(link)}
              >
                <div>{text}</div>
                <svg
                  className="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="m9 5 7 7-7 7"
                  />
                </svg>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div id="navbar" className={clsx(themeClass.bg('home'), `fixed top-0 bg-white left-0 w-full z-20 h-14 px-5 flex justify-between items-center`)}>
        {!match && (
          <div className="w-[560px] mx-auto lg:w-[54em]  xl:w-[90em] flex justify-between items-center">
            <Link
              to="/"
              className={`transition-all duration-300 flex ${
                isSearch
                  ? "opacity-0 scale-0 absolute"
                  : "opacity-100 scale-100 relative"
              }`}
            >
              <img src={logoNavbar} alt="Logo" className="h-8 mx-auto p-1" />
              <div className={clsx(grayscaleLogo ? `flex items-center relative h-8 w-[150px]` : 'hidden')}>
                <img
                  src={LogoKR}
                  alt="LogoKR"
                  className={`h-8 mx-auto p-1 absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                    showKorean ? "opacity-100" : "opacity-0"
                  }`}
                />
                <img
                  src={LogoEN}
                  alt="LogoEN"
                  className={`h-8 mx-auto p-1 absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                    showKorean ? "opacity-0" : "opacity-100"
                  }`}
                />
              </div>
            </Link>

            <div
              className={`${
                isHidden ? "hidden" : "relative flex-1 text-center"
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
                  isSearch
                    ? "opacity-100 scale-100"
                    : "opacity-0 scale-0 pointer-events-none"
                }`}
              >
                <form
                  className="flex items-center bg-white rounded-md px-3 py-1 shadow w-full search-container"
                  onSubmit={handleSearch}
                >
                  {/* 검색 버튼 제거 - x 버튼만 사용 */}
                  <input
                    type="text"
                    id="default-search"
                    name="default-search"
                    className="flex-1 p-1 text-sm bg-white border-0 focus:ring-white focus:border-gray-100 outline-none"
                    placeholder="검색어를 입력하세요"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSearch(e);
                        // 엔터 후에도 포커스 유지
                        e.currentTarget.focus();
                      } else if (e.key === "Escape") {
                        // ESC 키로 검색창 닫기
                        closeSearch();
                      }
                    }}
                    onBlur={(e) => {
                      // 검색창 내부 클릭시는 blur 무시
                      const relatedTarget = e.relatedTarget;
                      if (
                        relatedTarget &&
                        relatedTarget.closest(".search-container")
                      ) {
                        return;
                      }

                      // blur 시 검색 실행
                      if (searchQuery.trim()) {
                        handleSearch(e);
                      }
                    }}
                    // autoFocus 제거
                  />
                  <button
                    type="button"
                    onClick={() => {
                      if (searchQuery.trim()) {
                        // 검색어가 있으면 검색어만 지우기
                        setSearchQuery("");
                        document.getElementById("default-search")?.focus();
                      } else {
                        // 검색어가 없으면 검색창 닫기
                        closeSearch();
                      }
                    }}
                    className="ml-2 p-2 text-gray-500 hover:text-gray-700"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </form>
              </div>
            </div>
            <div
              className={`${
                isHidden
                  ? "hidden"
                  : "cursor-pointer transition-all duration-300"
              } ${
                isSearch
                  ? "opacity-0 scale-0 pointer-events-none"
                  : "opacity-100 scale-100"
              }`}
              onClick={buttonSearch}
            >
              <div className="opacity-100 scale-100">
                <svg
                  className={themeClass.text2('text2')}
                  width="1.5em"
                  height="1.5em"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
            </div>
            <div>
              <button
                className="opacity-100 scale-100 pl-3"
                onClick={handleMypageClick}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="1.75em"
                  height="1.75em"
                  className={themeClass.text2('text2')}
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  >
                    <circle cx="12" cy="7" r="4"></circle>
                    <path d="M5.338 18.32C5.999 15.528 8.772 14 11.643 14h.714c2.871 0 5.644 1.527 6.305 4.32c.128.541.23 1.107.287 1.682c.055.55-.397.998-.949.998H6c-.552 0-1.004-.449-.949-.998c.057-.575.159-1.14.287-1.681Z"></path>
                  </g>
                </svg>
              </button>

              <button className="pl-3" onClick={toggleSidebar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="1.7em"
                  height="1.7em"
                  className={themeClass.text2('text2')}
                >
                  <path
                    fill="currentColor"
                    d="M2 5h20v2H2zm0 6h20v2H2zm20 6H2v2h20z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        )}
        {match && (
          <div className="max-w-xl mx-auto w-full">
            <div className=" flex justify-between items-center ">
              <div className="">
                <img src={logoNavbar} alt="" className="h-6" />
              </div>
              <div className="font-semibold text-[#0F1E6C]">체험단 가이드 </div>
            </div>
          </div>
        )}
      </div>
      {/* <div className="fixed bottom-0 w-full bg-[#ffffff] py-3 shadow shadow-md z-10">
        <div className="justify-items-center grid grid-cols-3">
          <Link to={'/'} onClick={()=>setNavIsAktif("home")} className={clsx(navIsAktif === 'home' ? themeClass.text('text') : 'grayscale opacity-50')}>
            <House className={`w-[2em] h-[2em]`}/>
            <span>내 집</span>
          </Link>
          <Link to={'/detailcategory/가게'} onClick={()=>setNavIsAktif("detailcategory")} className={clsx(navIsAktif === 'detailcategory' ? themeClass.text('text') : 'grayscale opacity-50')}>
            <MapPinHouse className={`w-[2em] h-[2em]`}/>
            <span>운동</span>
          </Link>
          <div onClick={()=>handleMypageClick()} className={clsx(navIsAktif === 'mypage' ? themeClass.text('text') : 'grayscale opacity-50')}>
            <CircleUserRound className={`w-[2em] h-[2em]`}/>
            <span>윤곽</span>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Navbar;
